import NotificationsList from "@component/notification-list";
import { NotificationProvider } from "@context/notification_context";
import UserProfileProvider from "@context/user_profile";
import MainRoutes from "@route/index";


function App() {
  return (
    <UserProfileProvider>
      <NotificationProvider
        apiBaseUrl={import.meta.env.VITE_TALENT_AI_BE_BASE_URL || ""}
      >
        <MainRoutes />
        <NotificationsList />
      </NotificationProvider>
    </UserProfileProvider>
  );
}

export default App;
